(function() {
  const ROOT = "more-addons-widget[data-more-addons-widget]";
  function toNumber(value) {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  }
  function toText(value) {
    return typeof value === "string" ? value.trim() : "";
  }
  function buildItemProperties(row) {
    if (!row) return {};
    const properties = {};
    const addonType = toText(row.dataset.addonType);
    const addonOption = toText(row.dataset.addonOption);
    const addonHeading = toText(row.dataset.addonHeading);
    const addonBadge = toText(row.dataset.addonBadge);
    if (addonType) properties["_Addon Type"] = addonType;
    if (addonOption) properties["_Addon Option"] = addonOption;
    if (addonHeading) properties["_Addon Heading"] = addonHeading;
    if (addonBadge) properties["_Addon Badge"] = addonBadge;
    return properties;
  }
  function buildItemKey(item) {
    const properties = item && typeof item.properties === "object" && item.properties ? item.properties : {};
    return [
      toNumber(item && item.id),
      Math.max(1, toNumber(item && item.quantity) || 1),
      toText(properties["_Addon Type"]),
      toText(properties["_Addon Option"]),
      toText(properties["_Addon Heading"]),
      toText(properties["_Addon Badge"])
    ].join("::");
  }
  function buildPreviewThumb(src, alt = "") {
    if (!src) return null;
    const wrapper = document.createElement("span");
    wrapper.className = "inline-flex h-[55.867px] w-[55.867px] shrink-0 items-center justify-center overflow-hidden rounded-full border-[0.61px] border-[#E5E5E5] bg-white";
    const image = document.createElement("img");
    image.src = src;
    image.alt = alt;
    image.loading = "lazy";
    image.className = "block h-full w-full object-contain";
    wrapper.appendChild(image);
    return wrapper;
  }
  const ACCORDION_CLOSED_Y = "-8px";
  const ACCORDION_OPEN_Y = "0px";
  const ACCORDION_TRANSITION = "height 260ms cubic-bezier(0.22, 1, 0.36, 1), opacity 180ms ease-out, transform 260ms cubic-bezier(0.22, 1, 0.36, 1)";
  function setHiddenState(element, hidden) {
    if (!element) return;
    element.hidden = hidden;
    element.classList.toggle("hidden", hidden);
  }
  function clearAccordionAnimation(body) {
    if (!body) return;
    if (body.__accordionFrame) {
      cancelAnimationFrame(body.__accordionFrame);
      body.__accordionFrame = null;
    }
    if (typeof body.__accordionCleanup === "function") {
      body.__accordionCleanup();
      body.__accordionCleanup = null;
    }
  }
  function finalizeAccordionState(body, expanded) {
    if (!body) return;
    clearAccordionAnimation(body);
    setHiddenState(body, !expanded);
    body.style.overflow = "hidden";
    body.style.height = expanded ? "auto" : "0px";
    body.style.opacity = expanded ? "1" : "0";
    body.style.transform = expanded ? `translateY(${ACCORDION_OPEN_Y})` : `translateY(${ACCORDION_CLOSED_Y})`;
    body.style.willChange = "";
  }
  function syncAccordionBody(body, expanded, { immediate = false } = {}) {
    if (!body) return;
    clearAccordionAnimation(body);
    body.style.transition = ACCORDION_TRANSITION;
    body.style.overflow = "hidden";
    if (immediate) {
      finalizeAccordionState(body, expanded);
      return;
    }
    setHiddenState(body, false);
    const startHeight = expanded ? body.getBoundingClientRect().height : body.getBoundingClientRect().height || body.scrollHeight;
    const targetHeight = expanded ? body.scrollHeight : 0;
    body.style.willChange = "height, opacity, transform";
    body.style.height = `${startHeight}px`;
    body.style.opacity = expanded && startHeight === 0 ? "0" : "1";
    body.style.transform = expanded ? `translateY(${ACCORDION_CLOSED_Y})` : `translateY(${ACCORDION_OPEN_Y})`;
    void body.offsetHeight;
    body.__accordionCleanup = () => {
      body.removeEventListener("transitionend", handleTransitionEnd);
    };
    function handleTransitionEnd(event) {
      if (event.target !== body || event.propertyName !== "height") return;
      finalizeAccordionState(body, expanded);
    }
    body.addEventListener("transitionend", handleTransitionEnd);
    body.__accordionFrame = requestAnimationFrame(() => {
      body.style.height = `${targetHeight}px`;
      body.style.opacity = expanded ? "1" : "0";
      body.style.transform = expanded ? `translateY(${ACCORDION_OPEN_Y})` : `translateY(${ACCORDION_CLOSED_Y})`;
    });
  }
  function getPreviewSource(row) {
    if (!row) return null;
    const image = row.querySelector("[data-more-addon-preview-source] img, img");
    const src = (image == null ? void 0 : image.getAttribute("src")) || (image == null ? void 0 : image.getAttribute("data-src")) || (image == null ? void 0 : image.currentSrc) || "";
    if (!src) return null;
    return {
      src,
      alt: (image == null ? void 0 : image.getAttribute("alt")) || toText(row.dataset.addonOption) || "Performance extra"
    };
  }
  function getWidgets() {
    return Array.from(document.querySelectorAll(ROOT));
  }
  function collectSelectedVariantIds() {
    return Array.from(
      new Set(
        getWidgets().flatMap(
          (widget) => typeof widget.getSelectedVariantIds === "function" ? widget.getSelectedVariantIds() : []
        )
      )
    );
  }
  function collectSelectedItems(options) {
    const quantity = Math.max(1, toNumber(options && options.quantity ? options.quantity : 1));
    const seen = /* @__PURE__ */ new Set();
    return getWidgets().flatMap(
      (widget) => typeof widget.getSelectedItems === "function" ? widget.getSelectedItems(quantity) : []
    ).filter((item) => {
      const id = toNumber(item && item.id);
      const key = buildItemKey(item);
      if (id <= 0 || seen.has(key)) return false;
      seen.add(key);
      return true;
    }).map((item) => {
      const nextItem = {
        id: toNumber(item.id),
        quantity: Math.max(1, toNumber(item.quantity) || quantity)
      };
      if (item && typeof item.properties === "object" && item.properties && Object.keys(item.properties).length) {
        nextItem.properties = item.properties;
      }
      return nextItem;
    });
  }
  function collectSelectedTotalCents() {
    return getWidgets().reduce(
      (sum, widget) => sum + (typeof widget.getSelectedTotalCents === "function" ? toNumber(widget.getSelectedTotalCents()) : 0),
      0
    );
  }
  function notifyAddonsChange() {
    const detail = {
      selectedVariantIds: collectSelectedVariantIds(),
      totalCents: collectSelectedTotalCents()
    };
    window.__lastMoreAddonsChange = detail;
    document.dispatchEvent(new CustomEvent("custom:moreaddons:change", { detail }));
  }
  function installGlobalApi() {
    window.MudifyMoreAddons = {
      getSelectedItems: collectSelectedItems,
      getSelectedVariantIds: collectSelectedVariantIds,
      getSelectedTotalCents: collectSelectedTotalCents,
      refresh() {
        getWidgets().forEach((widget) => {
          if (typeof widget.refresh === "function") {
            widget.refresh(false);
          }
        });
        notifyAddonsChange();
      }
    };
  }
  class MoreAddonsWidget extends HTMLElement {
    connectedCallback() {
      if (this.dataset.moreAddonsInit === "true") return;
      this.dataset.moreAddonsInit = "true";
      this.__onToggle = () => {
        if (!this.isCollapsible()) return;
        this.setCollapsedState(!this.classList.contains("is-collapsed"));
      };
      this.sortRowsByDataSort();
      this.bindWidgetToggle();
      this.initRows();
      this.syncPreviewImages();
      this.syncTotalInDom();
      const shouldStartCollapsed = this.isCollapsible() && this.dataset.moreAddonsDefaultOpen !== "true";
      this.setCollapsedState(shouldStartCollapsed, { immediate: true });
      notifyAddonsChange();
    }
    disconnectedCallback() {
      if (this.dataset.moreAddonsInit !== "true") return;
      if (this.__toggleArea && this.__onToggle) {
        this.__toggleArea.removeEventListener("click", this.__onToggle);
      }
      notifyAddonsChange();
    }
    isCollapsible() {
      return this.dataset.moreAddonsCollapsible !== "false" && Boolean(this.querySelector("[data-more-addons-toggle]"));
    }
    getRows() {
      return Array.from(this.querySelectorAll("[data-more-addon-row]"));
    }
    getSelectedRows() {
      return this.getRows().filter((row) => row.dataset.selected === "yes");
    }
    getSelectedVariantIds() {
      return Array.from(
        new Set(
          this.getSelectedRows().map((row) => toNumber(row.dataset.variantId)).filter((id) => id > 0)
        )
      );
    }
    getSelectedItems(quantity = 1) {
      const qty = Math.max(1, toNumber(quantity) || 1);
      return this.getSelectedRows().map((row) => {
        const item = {
          id: toNumber(row.dataset.variantId),
          quantity: qty
        };
        const properties = buildItemProperties(row);
        if (Object.keys(properties).length) {
          item.properties = properties;
        }
        return item;
      }).filter((item) => item.id > 0);
    }
    getSelectedTotalCents() {
      return this.getSelectedRows().reduce(
        (sum, row) => sum + toNumber(row.dataset.price),
        0
      );
    }
    refresh(emit = true) {
      this.initRows();
      this.syncPreviewImages();
      this.syncTotalInDom();
      if (emit) notifyAddonsChange();
    }
    sortRowsByDataSort() {
      const body = this.querySelector("[data-more-addons-body]");
      if (!body) return;
      this.getRows().sort((a, b) => {
        const aRaw = (a.dataset.sort || "").trim();
        const bRaw = (b.dataset.sort || "").trim();
        const aNum = Number(aRaw);
        const bNum = Number(bRaw);
        if (Number.isFinite(aNum) && Number.isFinite(bNum)) {
          if (aNum === bNum) return 0;
          return aNum - bNum;
        }
        return aRaw.localeCompare(bRaw, void 0, {
          numeric: true,
          sensitivity: "base"
        });
      }).forEach((row) => body.appendChild(row));
    }
    setCollapsedState(isCollapsed, options = {}) {
      const collapsible = this.isCollapsible();
      const nextCollapsed = collapsible ? Boolean(isCollapsed) : false;
      const { immediate = false } = options;
      const toggleArea = this.querySelector("[data-more-addons-toggle]");
      const toggleContent = this.querySelector("[data-more-addons-toggle-content]");
      const body = this.querySelector("[data-more-addons-body]");
      const preview = this.querySelector("[data-more-addons-preview]");
      const toggleButton = this.querySelector(".more-addons-toggle-btn") || toggleArea;
      const toggleText = this.querySelector(".more-addons-toggle-text");
      const arrow = this.querySelector(".more-addons-toggle-arrow");
      this.classList.toggle("is-collapsed", nextCollapsed);
      if (toggleArea) {
        toggleArea.hidden = !collapsible;
        toggleArea.classList.toggle("justify-between", nextCollapsed);
        toggleArea.classList.toggle("justify-end", !nextCollapsed);
      }
      if (toggleContent) {
        toggleContent.hidden = !nextCollapsed;
        toggleContent.classList.toggle("hidden", !nextCollapsed);
      }
      if (body) {
        syncAccordionBody(body, !(collapsible ? nextCollapsed : false), { immediate });
      }
      if (preview) {
        preview.hidden = !nextCollapsed;
        preview.classList.toggle("hidden", !nextCollapsed);
      }
      if (toggleButton) {
        toggleButton.setAttribute("aria-expanded", nextCollapsed ? "false" : "true");
      }
      if (toggleText) {
        toggleText.textContent = nextCollapsed ? "Click To Expand" : "Click To Close";
      }
      if (arrow) {
        arrow.classList.toggle("rotate-180", !nextCollapsed);
      }
    }
    syncPreviewImages() {
      const container = this.querySelector("[data-more-addons-preview-images]");
      if (!container) return;
      container.replaceChildren();
      const previews = this.getRows().map((row) => getPreviewSource(row)).filter(Boolean).slice(0, 3);
      previews.forEach(({ src, alt }) => {
        const thumb = buildPreviewThumb(src, alt);
        if (thumb) container.appendChild(thumb);
      });
      container.hidden = previews.length === 0;
    }
    setRowState(row, selectedState) {
      const normalizedState = selectedState === "yes" || selectedState === "no" ? selectedState : "none";
      const yesBtn = row.querySelector("[data-more-addon-choice='yes']");
      const noBtn = row.querySelector("[data-more-addon-choice='no']");
      if (yesBtn) {
        const isYesSelected = normalizedState === "yes";
        yesBtn.classList.toggle("is-active", isYesSelected);
        yesBtn.setAttribute("aria-pressed", isYesSelected ? "true" : "false");
      }
      if (noBtn) {
        const isNoSelected = normalizedState === "no";
        noBtn.classList.toggle("is-active", isNoSelected);
        noBtn.setAttribute("aria-pressed", isNoSelected ? "true" : "false");
      }
      row.classList.toggle("is-selected", normalizedState === "yes");
      row.dataset.selected = normalizedState;
    }
    syncTotalInDom() {
      const total = String(this.getSelectedTotalCents());
      this.querySelectorAll("[data-more-addons-total]").forEach((input) => {
        if ("value" in input) {
          input.value = total;
        }
        input.setAttribute("value", total);
        input.dataset.value = total;
      });
    }
    bindWidgetToggle() {
      if (this.dataset.moreAddonsLocalDisclosure === "true") return;
      const toggleArea = this.querySelector("[data-more-addons-toggle]");
      if (!toggleArea || toggleArea.dataset.moreAddonsToggleBound === "true") return;
      toggleArea.dataset.moreAddonsToggleBound = "true";
      this.__toggleArea = toggleArea;
      toggleArea.addEventListener("click", this.__onToggle);
    }
    bindRowToggle(row) {
      const buttons = row.querySelectorAll("[data-more-addon-choice]");
      if (!buttons.length || row.dataset.moreAddonsRowBound === "true") return;
      row.dataset.moreAddonsRowBound = "true";
      const toggleRowState = (clickedChoice) => {
        const currentState = row.dataset.selected === "yes" || row.dataset.selected === "no" ? row.dataset.selected : "none";
        const nextState = currentState === clickedChoice ? "none" : clickedChoice;
        this.setRowState(row, nextState);
        this.syncTotalInDom();
        notifyAddonsChange();
      };
      buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.stopPropagation();
          if (button.disabled) return;
          toggleRowState(button.dataset.moreAddonChoice);
        });
      });
      if (row.dataset.moreAddonsRowToggle === "true") {
        row.addEventListener("click", (event) => {
          if (event.target.closest("a, button")) return;
          const yesButton = row.querySelector("[data-more-addon-choice='yes']");
          if (!yesButton || yesButton.disabled) return;
          toggleRowState("yes");
        });
      }
    }
    initRows() {
      this.getRows().forEach((row) => {
        const currentState = row.dataset.selected === "yes" || row.dataset.selected === "no" ? row.dataset.selected : "none";
        const yesBtn = row.querySelector("[data-more-addon-choice='yes']");
        const isYesAllowed = Boolean(yesBtn) && !yesBtn.disabled;
        const selectedState = currentState === "yes" && isYesAllowed ? "yes" : currentState === "no" ? "no" : "none";
        this.setRowState(row, selectedState);
        this.bindRowToggle(row);
      });
    }
  }
  if (!window.customElements.get("more-addons-widget")) {
    window.customElements.define("more-addons-widget", MoreAddonsWidget);
  }
  installGlobalApi();
  if (!window.__lastMoreAddonsChange) {
    window.__lastMoreAddonsChange = {
      selectedVariantIds: [],
      totalCents: 0
    };
  }
})();
